import AuthService from "./auth.service";

import axios from "axios";
const Axios = axios.create();

// Function to check token expiry
export const isTokenExpires = (token) => {
  let flag = true;
  if (!!token) {
    const jwtPayload = JSON.parse(window.atob(token.split(".")[1]));
    const expiryTime = new Date(jwtPayload.exp * 1000);
    const currentTime = new Date();

    if (currentTime.getTime() < expiryTime.getTime()) {
      flag = false;
    }
  }
  return flag;
};

// Request interceptor for API calls
Axios.interceptors.request.use(
  async (config) => {
    const token = JSON.parse(localStorage.getItem("token"));

    // check if the token is expired, if yes trigger logOut
    if (isTokenExpires(token)) {
      // Just updating it to reload the page, since the token is no longer available
      // The user will redirected to the login page
      window.location.href = window.location.href;
      AuthService.logout();
    }

    config.headers = {
      Authorization: token,
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

export default Axios;
